import { takeEvery, takeLatest, all } from 'redux-saga/effects';
import { AppTypes, CommunityTypes, CompanyTypes, DevelopTypes, ManageTypes, VendorTypes } from '~/actions';
import API from '~/services/api';

import {
    loginRequest,
    logoutRequest,
    refreshRequest,
    getslugRequest,
    emailverificationRequest,
    getauthoringRequest,
    getusercompaniesRequest,
    getcompanyvendorRequest,
    getlibraryfiltersRequest,
    uploadRequest,
    getcompaniesRequest,
    getcompanyRequest,
    posteditprofileRequest,
    postcompanyusersRequest,
    fetchnotificationsRequest,
    updatenotificationsRequest,
    advancedsearchRequest,
    postrecoverypasswordRequest,
    postmulticompanydataRequest,
    postmulticompanyemployeesRequest,
    getallauthorsRequest,
    postsaveauthorRequest,
    postsavebusinessauthorRequest,
    postdeleteauthorRequest,
    getcommunityusersRequest,
    getentityconnectionsRequest,
    getemployeesearchRequest,
    getuserjobdescriptionRequest,
    getuserhealthplanRequest,
} from './app';
import {
    getlearnfeedsRequest,
    postlibrarycardtemplatesRequest,
    getlibrarytemplatesRequest,
    getlibrarytemplatessearchRequest,
    dailytrainingRequest,
    librarytemplatesaveRequest,
    librarycardtemplatesRequest,
    libraryeventRequest,
    libraryprogramdetailRequest,
    quotatemplatesRequest,
    trainingscheduledetailRequest,
    librarysaveRequest,
    questionRequest,
    answerRequest,
    resetquizRequest,
    createquotaRequest,
    getquotaoptionsRequest,
    adddocumentRequest,
    deletedocumentRequest,
    careergoalsRequest,
    careergoalsaveRequest,
    careerdevreportsRequest,
    careertasksRequest,
    careertrainingsRequest,
    userscoursereportRequest,
    teamreportsRequest,
    traininglistRequest,
    updatemoduleRequest,
    updatecardRequest,
    getscormlinkRequest,
    updatecardinstanceRequest,
    careerpromoteRequest,
    careerApprovalTaskRequest,
    adddevcommentRequest,
    postcompanyinfoRequest,
    fetchnotificationssettingsRequest,
    updatenotificationssettingsRequest,
    programeventRequest,
    programpromotionRequest,
    postscorecardsaveRequest,
    postterminateuserRequest,
    postdeleteuserRequest,
    getassessmentsRequest,
    getuserprogramsRequest,
    getuserscorecardsRequest,
} from './develop';
import {
    getcareerprogramRequest,
    postcareerprogramRequest,
    gettasksfeedRequest,
    companyprojectsRequest,
    selectprojectRequest,
    edittaskRequest,
    deletetaskRequest,
    fetchtaskdetailRequest,
    selectusersRequest,
    userprojecttaskRequest,
    addmngcommentRequest,
    addtaskRequest,
    searchmodulesRequest,
    assigncoursesRequest,
    assigntrainingRequest,
    unassigncontentRequest,
    fetchcompanycareersRequest,
    fetchprojectsdetailRequest,
    updatetaskRequest,
    addprojectRequest,
    updateprojectRequest,
    deleteprojectRequest,
    companyindividualRequest,
    fetchengagementreportRequest,
    fetchcertificationsreportRequest,
    fetchcareerreportsRequest,
    fetchhireorientationreportRequest,
    companyperformancereviewsRequest,
    companyperformancereviewsstatsRequest,
    companydailycheckoutsRequest,
    getcompanycheckoutsRequest,
    individualperformancereviewRequest,
    postperformancereviewRequest,
    postperformancereviewresetRequest,
    getperformancereviewsRequest,
    getpreviousreviewtasksRequest,
    getmanagerdashboardRequest,
    postquotaactualsRequest,
    getanniversarybirthdayRequest,
    posttrainingreportsRequest,
    postquotaactualcommentRequest,
    postupdateactualcommentsRequest,
    postsignoffRequest,
    postquotareportRequest,
    posttrainingcompetencyreportRequest,
    postterminateemployeeRequest,
    postindividualquotareportRequest,
    getquotasactualsRequest,
    getcompanyorgchartRequest,
    getsaveactualsreportRequest,
    getcheckoutactualsRequest,
    getcheckoutorgchartRequest,
    posttrainingtrackreportRequest,
    trainingtrackdetailreportRequest,
    postteamactivityreportRequest,
    postdeletescorecardRequest,
    getdailyfeedRequest,
    getcheckoutRequest,
    postaddcheckoutcommentRequest,
    postcheckouteditRequest,
    postcheckoutsignoffRequest,
    postcheckoutskipdayRequest,
    postcheckoutresetRequest,
    postcheckoutapproveRequest,
} from './manage';

import {
    getcategoriesRequest,
    getcategorypopularproductsRequest,
    getallcategorypopularproductsRequest,
    getcategoryproductsRequest,
    getcompanyadminsRequest,
    getvendorcompanyRequest,
    getvendorcompaniesRequest,
    getallvendorcompaniesRequest,
    savevendorratingRequest,
    getvendorawardsRequest,
    getrecentlyupdatedproductsRequest,
    getpopularproductsRequest,
    globalsearchRequest,
    savevrproductRequest,
    savevrcompanyRequest,
    savevrphotoRequest,
    getvrcompanyRequest,
    postvrcompanyadminRequest,
    postblogadminRequest,
    getblogRequest,
    saveblogRequest,
    getblogpostsRequest,
    saveblogpostRequest,
    deleteblogpostRequest,
    postadduserRequest,
    postremoveuserRequest,
    postsaveproductRequest,
    postsavecontentRequest,
    postsavevrmediaRequest,
    postsaveproductmediaRequest,
    postdeleteproductmediaRequest,
    getvrcompanydetailRequest,
    getsuperadminbusinessRequest,
    getsuperadminusersRequest,
    getsuperadmincontentRequest,
    postvendorconnectRequest,
    getvendorcategoriesRequest,
    getvendorratingsRequest,
    postsuperadminbanduserRequest,
    postsuperadminrestoreuserRequest,
    postcategorysaveRequest,
    postcategorydeleteRequest,
    postcategoryrestoreRequest,
    postvendorratingRequest,
} from './vendor';

import {
    postcreateblogRequest,
    addforumtopicRequest,
    getforumindividualtopicRequest,
    addtopiccommentRequest,
    editforumtopicRequest,
    deleteforumtopicRequest,
    getcommunityblogRequest,
    getblogsummaryRequest,
    getblogdetailsRequest,
    getcommunityuserRequest,
    getcommunityconnectionsRequest,
    postcommunityconnectRequest,
    getuserpermissionsRequest,
    postpasswordchangeRequest,
    postunfollowRequest,
    postconnectionupdateRequest,
    postcommunityuserRequest,
    postsaveusercontentRequest,
    postregisteruserRequest,
    gettopicsRequest,
    getalldepartmentforumtopicsRequest,
    getcomblogpostsRequest,
    geteditfeatureditemsRequest,
    getfeatureditemsRequest,
    postsavefeatureditemRequest,
    postarchivefeatureditemRequest,
    getcategorysponsoredproductsRequest,
    postsavecommentRequest,
    postcontentflagRequest,
    addcontenteventRequest,
    featuredpostsRequest,
    getemployersearchRequest,
    getfeaturedcategoriesRequest,
} from './community';

import {
    getbusinessRequest,
    postbusinessRequest,
    getbusinessblogRequest,
    getbzcompanyRequest,
    savebzcompanyRequest,
    savebusinessRequest,
    getblogcategoriesRequest,
    gettopiccategoriesRequest,
    getcompanyusersRequest,
    postregisterbusinessuserRequest,
    postaddeditdepartmentsRequest,
    postaddeditteamsRequest,
    postdeleteteamRequest,
    postsavejobrolesRequest,
    postsavehcmcompanyRequest,
    getminimalcompanyemployeesRequest,
    postcompanyfollowRequest,
    postcompanyconnectRequest,
    getcompanyconnectionsRequest,
    postdeletedepartmentRequest,
    getusersubscriptionsRequest,
    getsubscriptionreportsRequest,
    getsubscriptionfrequenciesRequest,
    postaddsubscriptionRequest,
    postsavesubscriptionRequest,
} from './company';

export const api = API.create();

export default function* root() {
    yield all([
        takeLatest(AppTypes.LOGIN_REQUEST, loginRequest, api),
        takeLatest(AppTypes.LOGOUT_REQUEST, logoutRequest, api),
        takeLatest(AppTypes.REFRESH_REQUEST, refreshRequest, api),
        takeLatest(AppTypes.GETSLUG_REQUEST, getslugRequest, api),
        takeLatest(AppTypes.EMAILVERIFICATION_REQUEST, emailverificationRequest, api),
        takeLatest(AppTypes.GETAUTHORING_REQUEST, getauthoringRequest, api),
        takeLatest(AppTypes.GETENTITYCONNECTIONS_REQUEST, getentityconnectionsRequest, api),
        takeLatest(AppTypes.GETUSERCOMPANIES_REQUEST, getusercompaniesRequest, api),
        takeLatest(AppTypes.GETCOMPANYVENDOR_REQUEST, getcompanyvendorRequest, api),
        takeLatest(AppTypes.GETLIBRARYFILTERS_REQUEST, getlibraryfiltersRequest, api),
        takeEvery(AppTypes.UPLOAD_REQUEST, uploadRequest, api),
        takeLatest(AppTypes.GETCOMPANIES_REQUEST, getcompaniesRequest, api),
        takeLatest(AppTypes.GETCOMPANY_REQUEST, getcompanyRequest, api),
        takeLatest(AppTypes.POSTEDITPROFILE_REQUEST, posteditprofileRequest, api),
        takeLatest(AppTypes.POSTCOMPANYUSERS_REQUEST, postcompanyusersRequest, api),
        takeLatest(AppTypes.FETCHNOTIFICATIONS_REQUEST, fetchnotificationsRequest, api),
        takeLatest(AppTypes.UPDATENOTIFICATIONS_REQUEST, updatenotificationsRequest, api),
        takeLatest(AppTypes.ADVANCEDSEARCH_REQUEST, advancedsearchRequest, api),
        takeLatest(AppTypes.POSTRECOVERYPASSWORD_REQUEST, postrecoverypasswordRequest, api),
        takeEvery(AppTypes.POSTMULTICOMPANYDATA_REQUEST, postmulticompanydataRequest, api),
        takeLatest(AppTypes.POSTMULTICOMPANYEMPLOYEES_REQUEST, postmulticompanyemployeesRequest, api),
        takeLatest(AppTypes.GETALLAUTHORS_REQUEST, getallauthorsRequest, api),
        takeLatest(AppTypes.POSTSAVEAUTHOR_REQUEST, postsaveauthorRequest, api),
        takeLatest(AppTypes.POSTSAVEBUSINESSAUTHOR_REQUEST, postsavebusinessauthorRequest, api),
        takeLatest(AppTypes.POSTDELETEAUTHOR_REQUEST, postdeleteauthorRequest, api),
        takeLatest(AppTypes.GETCOMMUNITYUSERS_REQUEST, getcommunityusersRequest, api),
        takeLatest(AppTypes.GETEMPLOYEESEARCH_REQUEST, getemployeesearchRequest, api),
        takeLatest(AppTypes.GETUSERJOBDESCRIPTION_REQUEST, getuserjobdescriptionRequest, api),
        takeLatest(AppTypes.GETUSERHEALTHPLAN_REQUEST, getuserhealthplanRequest, api),

        takeEvery(DevelopTypes.GETLEARNFEEDS_REQUEST, getlearnfeedsRequest, api),
        takeLatest(DevelopTypes.POSTLIBRARYCARDTEMPLATES_REQUEST, postlibrarycardtemplatesRequest, api),
        takeLatest(DevelopTypes.GETLIBRARYTEMPLATES_REQUEST, getlibrarytemplatesRequest, api),
        takeLatest(DevelopTypes.GETLIBRARYTEMPLATESSEARCH_REQUEST, getlibrarytemplatessearchRequest, api),
        takeLatest(DevelopTypes.DAILYTRAINING_REQUEST, dailytrainingRequest, api),
        takeLatest(DevelopTypes.UPDATECARD_REQUEST, updatecardRequest, api),
        takeLatest(DevelopTypes.GETSCORMLINK_REQUEST, getscormlinkRequest, api),
        takeLatest(DevelopTypes.POSTSCORECARDSAVE_REQUEST, postscorecardsaveRequest, api),
        takeLatest(DevelopTypes.UPDATECARDINSTANCE_REQUEST, updatecardinstanceRequest, api),
        takeLatest(DevelopTypes.LIBRARYTEMPLATESAVE_REQUEST, librarytemplatesaveRequest, api),
        takeLatest(DevelopTypes.LIBRARYCARDTEMPLATES_REQUEST, librarycardtemplatesRequest, api),
        takeLatest(DevelopTypes.LIBRARYEVENT_REQUEST, libraryeventRequest, api),
        takeLatest(DevelopTypes.LIBRARYPROGRAMDETAIL_REQUEST, libraryprogramdetailRequest, api),
        takeLatest(DevelopTypes.QUOTATEMPLATES_REQUEST, quotatemplatesRequest, api),
        takeLatest(DevelopTypes.TRAININGSCHEDULEDETAIL_REQUEST, trainingscheduledetailRequest, api),
        takeLatest(DevelopTypes.LIBRARYSAVE_REQUEST, librarysaveRequest, api),
        takeLatest(DevelopTypes.QUESTION_REQUEST, questionRequest, api),
        takeLatest(DevelopTypes.ANSWER_REQUEST, answerRequest, api),
        takeLatest(DevelopTypes.RESETQUIZ_REQUEST, resetquizRequest, api),
        takeLatest(DevelopTypes.CREATEQUOTA_REQUEST, createquotaRequest, api),
        takeLatest(DevelopTypes.GETQUOTAOPTIONS_REQUEST, getquotaoptionsRequest, api),
        takeLatest(DevelopTypes.ADDDOCUMENT_REQUEST, adddocumentRequest, api),
        takeLatest(DevelopTypes.DELETEDOCUMENT_REQUEST, deletedocumentRequest, api),
        takeLatest(DevelopTypes.CAREERGOALS_REQUEST, careergoalsRequest, api),
        takeLatest(DevelopTypes.CAREERGOALSAVE_REQUEST, careergoalsaveRequest, api),
        takeLatest(DevelopTypes.CAREERDEVREPORTS_REQUEST, careerdevreportsRequest, api),
        takeLatest(DevelopTypes.CAREERTASKS_REQUEST, careertasksRequest, api),
        takeLatest(DevelopTypes.CAREERTRAININGS_REQUEST, careertrainingsRequest, api),
        takeLatest(DevelopTypes.USERSCOURSEREPORT_REQUEST, userscoursereportRequest, api),
        takeLatest(DevelopTypes.TEAMREPORTS_REQUEST, teamreportsRequest, api),
        takeLatest(DevelopTypes.TRAININGLIST_REQUEST, traininglistRequest, api),
        takeLatest(DevelopTypes.UPDATEMODULE_REQUEST, updatemoduleRequest, api),
        takeLatest(DevelopTypes.CAREERPROMOTE_REQUEST, careerpromoteRequest, api),
        takeLatest(DevelopTypes.CAREERCARD_REQUEST, careerApprovalTaskRequest, api),
        takeLatest(DevelopTypes.ADDDEVCOMMENT_REQUEST, adddevcommentRequest, api),
        takeLatest(DevelopTypes.POSTCOMPANYINFO_REQUEST, postcompanyinfoRequest, api),
        takeLatest(DevelopTypes.FETCHNOTIFICATIONSSETTINGS_REQUEST, fetchnotificationssettingsRequest, api),
        takeLatest(DevelopTypes.UPDATENOTIFICATIONSSETTINGS_REQUEST, updatenotificationssettingsRequest, api),
        takeLatest(DevelopTypes.PROGRAMEVENT_REQUEST, programeventRequest, api),
        takeLatest(DevelopTypes.PROGRAMPROMOTION_REQUEST, programpromotionRequest, api),
        takeLatest(DevelopTypes.POSTTERMINATEUSER_REQUEST, postterminateuserRequest, api),
        takeLatest(DevelopTypes.POSTDELETEUSER_REQUEST, postdeleteuserRequest, api),
        takeLatest(DevelopTypes.GETASSESSMENTS_REQUEST, getassessmentsRequest, api),
        takeLatest(DevelopTypes.GETUSERPROGRAMS_REQUEST, getuserprogramsRequest, api),
        takeLatest(DevelopTypes.GETUSERSCORECARDS_REQUEST, getuserscorecardsRequest, api),

        takeLatest(ManageTypes.GETCAREERPROGRAM_REQUEST, getcareerprogramRequest, api),
        takeLatest(ManageTypes.POSTCAREERPROGRAM_REQUEST, postcareerprogramRequest, api),
        takeLatest(ManageTypes.GETTASKSFEED_REQUEST, gettasksfeedRequest, api),
        takeLatest(ManageTypes.COMPANYPROJECTS_REQUEST, companyprojectsRequest, api),
        takeLatest(ManageTypes.SELECTPROJECT_REQUEST, selectprojectRequest, api),
        takeLatest(ManageTypes.EDITTASK_REQUEST, edittaskRequest, api),
        takeLatest(ManageTypes.DELETETASK_REQUEST, deletetaskRequest, api),
        takeLatest(ManageTypes.FETCHTASKDETAIL_REQUEST, fetchtaskdetailRequest, api),
        takeLatest(ManageTypes.SELECTUSERS_REQUEST, selectusersRequest, api),
        takeEvery(ManageTypes.USERPROJECTTASK_REQUEST, userprojecttaskRequest, api),
        takeEvery(ManageTypes.ADDMNGCOMMENT_REQUEST, addmngcommentRequest, api),
        takeLatest(ManageTypes.ADDTASK_REQUEST, addtaskRequest, api),
        takeLatest(ManageTypes.SEARCHMODULES_REQUEST, searchmodulesRequest, api),
        takeLatest(ManageTypes.ASSIGNCOURSES_REQUEST, assigncoursesRequest, api),
        takeLatest(ManageTypes.ASSIGNTRAINING_REQUEST, assigntrainingRequest, api),
        takeLatest(ManageTypes.UNASSIGNCONTENT_REQUEST, unassigncontentRequest, api),
        takeLatest(ManageTypes.FETCHPROJECTSDETAIL_REQUEST, fetchprojectsdetailRequest, api),
        takeEvery(ManageTypes.UPDATETASK_REQUEST, updatetaskRequest, api),
        takeLatest(ManageTypes.ADDPROJECT_REQUEST, addprojectRequest, api),
        takeLatest(ManageTypes.UPDATEPROJECT_REQUEST, updateprojectRequest, api),
        takeLatest(ManageTypes.DELETEPROJECT_REQUEST, deleteprojectRequest, api),
        takeLatest(ManageTypes.COMPANYINDIVIDUAL_REQUEST, companyindividualRequest, api),
        takeLatest(ManageTypes.FETCHENGAGEMENTREPORT_REQUEST, fetchengagementreportRequest, api),
        takeLatest(ManageTypes.FETCHCERTIFICATIONSREPORT_REQUEST, fetchcertificationsreportRequest, api),
        takeLatest(ManageTypes.FETCHCAREERREPORTS_REQUEST, fetchcareerreportsRequest, api),
        takeLatest(ManageTypes.FETCHHIREORIENTATIONREPORT_REQUEST, fetchhireorientationreportRequest, api),
        takeLatest(ManageTypes.FETCHCOMPANYCAREERS_REQUEST, fetchcompanycareersRequest, api),
        takeLatest(ManageTypes.COMPANYPERFORMANCEREVIEWS_REQUEST, companyperformancereviewsRequest, api),
        takeLatest(ManageTypes.COMPANYPERFORMANCEREVIEWSSTATS_REQUEST, companyperformancereviewsstatsRequest, api),

        takeLatest(ManageTypes.COMPANYDAILYCHECKOUTS_REQUEST, companydailycheckoutsRequest, api),
        takeLatest(ManageTypes.GETCOMPANYCHECKOUTS_REQUEST, getcompanycheckoutsRequest, api),
        takeLatest(ManageTypes.INDIVIDUALPERFORMANCEREVIEW_REQUEST, individualperformancereviewRequest, api),
        takeLatest(ManageTypes.GETPERFORMANCEREVIEWS_REQUEST, getperformancereviewsRequest, api),
        takeLatest(ManageTypes.GETPREVIOUSREVIEWTASKS_REQUEST, getpreviousreviewtasksRequest, api),
        takeLatest(ManageTypes.POSTPERFORMANCEREVIEW_REQUEST, postperformancereviewRequest, api),
        takeLatest(ManageTypes.POSTPERFORMANCEREVIEWRESET_REQUEST, postperformancereviewresetRequest, api),
        takeLatest(ManageTypes.GETMANAGERDASHBOARD_REQUEST, getmanagerdashboardRequest, api),
        takeLatest(ManageTypes.POSTQUOTAACTUALS_REQUEST, postquotaactualsRequest, api),
        takeLatest(ManageTypes.GETANNIVERSARYBIRTHDAY_REQUEST, getanniversarybirthdayRequest, api),
        takeLatest(ManageTypes.POSTTRAININGREPORTS_REQUEST, posttrainingreportsRequest, api),
        takeLatest(ManageTypes.POSTQUOTAACTUALCOMMENT_REQUEST, postquotaactualcommentRequest, api),
        takeLatest(ManageTypes.POSTUPDATEACTUALCOMMENTS_REQUEST, postupdateactualcommentsRequest, api),
        takeLatest(ManageTypes.POSTSIGNOFF_REQUEST, postsignoffRequest, api),
        takeLatest(ManageTypes.POSTQUOTAREPORT_REQUEST, postquotareportRequest, api),
        takeLatest(ManageTypes.POSTTRAININGCOMPETENCYREPORT_REQUEST, posttrainingcompetencyreportRequest, api),
        takeLatest(ManageTypes.POSTTERMINATEEMPLOYEE_REQUEST, postterminateemployeeRequest, api),
        takeLatest(ManageTypes.POSTINDIVIDUALQUOTAREPORT_REQUEST, postindividualquotareportRequest, api),
        takeLatest(ManageTypes.GETQUOTASACTUALS_REQUEST, getquotasactualsRequest, api),
        takeLatest(ManageTypes.GETCOMPANYORGCHART_REQUEST, getcompanyorgchartRequest, api),
        takeLatest(ManageTypes.GETSAVEACTUALSREPORT_REQUEST, getsaveactualsreportRequest, api),
        takeLatest(ManageTypes.GETCHECKOUTACTUALS_REQUEST, getcheckoutactualsRequest, api),
        takeLatest(ManageTypes.GETCHECKOUTORGCHART_REQUEST, getcheckoutorgchartRequest, api),
        takeLatest(ManageTypes.POSTTRAININGTRACKREPORT_REQUEST, posttrainingtrackreportRequest, api),
        takeLatest(ManageTypes.TRAININGTRACKDETAILREPORT_REQUEST, trainingtrackdetailreportRequest, api),
        takeLatest(ManageTypes.POSTTEAMACTIVITYREPORT_REQUEST, postteamactivityreportRequest, api),
        takeLatest(ManageTypes.POSTDELETESCORECARD_REQUEST, postdeletescorecardRequest, api),
        takeLatest(ManageTypes.GETDAILYFEED_REQUEST, getdailyfeedRequest, api),
        takeLatest(ManageTypes.GETCHECKOUT_REQUEST, getcheckoutRequest, api),
        takeLatest(ManageTypes.POSTADDCHECKOUTCOMMENT_REQUEST, postaddcheckoutcommentRequest, api),
        takeLatest(ManageTypes.POSTCHECKOUTEDIT_REQUEST, postcheckouteditRequest, api),
        takeLatest(ManageTypes.POSTCHECKOUTSIGNOFF_REQUEST, postcheckoutsignoffRequest, api),
        takeLatest(ManageTypes.POSTCHECKOUTSKIPDAY_REQUEST, postcheckoutskipdayRequest, api),
        takeLatest(ManageTypes.POSTCHECKOUTRESET_REQUEST, postcheckoutresetRequest, api),
        takeLatest(ManageTypes.POSTCHECKOUTAPPROVE_REQUEST, postcheckoutapproveRequest, api),

        takeLatest(VendorTypes.GETCATEGORIES_REQUEST, getcategoriesRequest, api),
        takeEvery(VendorTypes.GETCATEGORYPOPULARPRODUCTS_REQUEST, getcategorypopularproductsRequest, api),
        takeLatest(VendorTypes.GETALLCATEGORYPOPULARPRODUCTS_REQUEST, getallcategorypopularproductsRequest, api),
        takeEvery(VendorTypes.GETCATEGORYPRODUCTS_REQUEST, getcategoryproductsRequest, api),
        takeLatest(VendorTypes.GETVENDORCOMPANY_REQUEST, getvendorcompanyRequest, api),
        takeLatest(VendorTypes.GETCOMPANYADMINS_REQUEST, getcompanyadminsRequest, api),
        takeLatest(VendorTypes.GETVENDORCOMPANIES_REQUEST, getvendorcompaniesRequest, api),
        takeLatest(VendorTypes.GETVRCOMPANYDETAIL_REQUEST, getvrcompanydetailRequest, api),
        takeLatest(VendorTypes.GETVENDORCATEGORIES_REQUEST, getvendorcategoriesRequest, api),
        takeLatest(VendorTypes.GETVENDORRATINGS_REQUEST, getvendorratingsRequest, api),
        takeLatest(VendorTypes.GETALLVENDORCOMPANIES_REQUEST, getallvendorcompaniesRequest, api),
        takeLatest(VendorTypes.POSTVRCOMPANYADMIN_REQUEST, postvrcompanyadminRequest, api),
        takeLatest(VendorTypes.POSTBLOGADMIN_REQUEST, postblogadminRequest, api),
        takeLatest(VendorTypes.SAVEVENDORRATING_REQUEST, savevendorratingRequest, api),
        takeLatest(VendorTypes.GETVENDORAWARDS_REQUEST, getvendorawardsRequest, api),
        takeLatest(VendorTypes.GETRECENTLYUPDATEDPRODUCTS_REQUEST, getrecentlyupdatedproductsRequest, api),
        takeLatest(VendorTypes.GETPOPULARPRODUCTS_REQUEST, getpopularproductsRequest, api),
        takeLatest(VendorTypes.GLOBALSEARCH_REQUEST, globalsearchRequest, api),
        takeLatest(VendorTypes.SAVEVRPRODUCT_REQUEST, savevrproductRequest, api),
        takeLatest(VendorTypes.SAVEVRCOMPANY_REQUEST, savevrcompanyRequest, api),
        takeLatest(VendorTypes.SAVEVRPHOTO_REQUEST, savevrphotoRequest, api),
        takeLatest(VendorTypes.GETVRCOMPANY_REQUEST, getvrcompanyRequest, api),
        takeLatest(VendorTypes.GETBLOG_REQUEST, getblogRequest, api),
        takeLatest(VendorTypes.SAVEBLOG_REQUEST, saveblogRequest, api),
        takeLatest(VendorTypes.GETBLOGPOSTS_REQUEST, getblogpostsRequest, api),
        takeLatest(VendorTypes.SAVEBLOGPOST_REQUEST, saveblogpostRequest, api),
        takeLatest(VendorTypes.DELETEBLOGPOST_REQUEST, deleteblogpostRequest, api),
        takeLatest(VendorTypes.POSTADDUSER_REQUEST, postadduserRequest, api),
        takeLatest(VendorTypes.POSTREMOVEUSER_REQUEST, postremoveuserRequest, api),
        takeLatest(VendorTypes.POSTSAVEPRODUCT_REQUEST, postsaveproductRequest, api),
        takeLatest(VendorTypes.POSTSAVECONTENT_REQUEST, postsavecontentRequest, api),
        takeLatest(VendorTypes.POSTSAVEVRMEDIA_REQUEST, postsavevrmediaRequest, api),
        takeEvery(VendorTypes.POSTSAVEPRODUCTMEDIA_REQUEST, postsaveproductmediaRequest, api),
        takeEvery(VendorTypes.POSTDELETEPRODUCTMEDIA_REQUEST, postdeleteproductmediaRequest, api),
        takeLatest(VendorTypes.GETSUPERADMINBUSINESS_REQUEST, getsuperadminbusinessRequest, api),
        takeLatest(VendorTypes.GETSUPERADMINUSERS_REQUEST, getsuperadminusersRequest, api),
        takeLatest(VendorTypes.GETSUPERADMINCONTENT_REQUEST, getsuperadmincontentRequest, api),
        takeLatest(VendorTypes.POSTVENDORCONNECT_REQUEST, postvendorconnectRequest, api),
        takeLatest(VendorTypes.POSTSUPERADMINBANDUSER_REQUEST, postsuperadminbanduserRequest, api),
        takeLatest(VendorTypes.POSTSUPERADMINRESTOREUSER_REQUEST, postsuperadminrestoreuserRequest, api),
        takeLatest(VendorTypes.POSTCATEGORYSAVE_REQUEST, postcategorysaveRequest, api),
        takeLatest(VendorTypes.POSTCATEGORYDELETE_REQUEST, postcategorydeleteRequest, api),
        takeLatest(VendorTypes.POSTCATEGORYRESTORE_REQUEST, postcategoryrestoreRequest, api),
        takeLatest(VendorTypes.POSTVENDORRATING_REQUEST, postvendorratingRequest, api),

        takeLatest(CompanyTypes.GETBUSINESS_REQUEST, getbusinessRequest, api),
        takeLatest(CompanyTypes.POSTBUSINESS_REQUEST, postbusinessRequest, api),
        takeLatest(CompanyTypes.GETBUSINESSBLOG_REQUEST, getbusinessblogRequest, api),
        takeLatest(CompanyTypes.GETBZCOMPANY_REQUEST, getbzcompanyRequest, api),
        takeLatest(CompanyTypes.SAVEBZCOMPANY_REQUEST, savebzcompanyRequest, api),
        takeLatest(CompanyTypes.SAVEBUSINESS_REQUEST, savebusinessRequest, api),
        takeLatest(CompanyTypes.GETBLOGCATEGORIES_REQUEST, getblogcategoriesRequest, api),
        takeLatest(CompanyTypes.GETTOPICCATEGORIES_REQUEST, gettopiccategoriesRequest, api),
        takeLatest(CompanyTypes.GETCOMPANYUSERS_REQUEST, getcompanyusersRequest, api),
        takeLatest(CompanyTypes.POSTREGISTERBUSINESSUSER_REQUEST, postregisterbusinessuserRequest, api),
        takeLatest(CompanyTypes.POSTADDEDITDEPARTMENTS_REQUEST, postaddeditdepartmentsRequest, api),
        takeLatest(CompanyTypes.POSTDELETEDEPARTMENT_REQUEST, postdeletedepartmentRequest, api),
        takeLatest(CompanyTypes.POSTADDEDITTEAMS_REQUEST, postaddeditteamsRequest, api),
        takeLatest(CompanyTypes.POSTDELETETEAM_REQUEST, postdeleteteamRequest, api),
        takeLatest(CompanyTypes.POSTSAVEJOBROLES_REQUEST, postsavejobrolesRequest, api),
        takeLatest(CompanyTypes.POSTSAVEHCMCOMPANY_REQUEST, postsavehcmcompanyRequest, api),
        takeLatest(CompanyTypes.GETMINIMALCOMPANYEMPLOYEES_REQUEST, getminimalcompanyemployeesRequest, api),
        takeLatest(CompanyTypes.POSTCOMPANYFOLLOW_REQUEST, postcompanyfollowRequest, api),
        takeLatest(CompanyTypes.POSTCOMPANYCONNECT_REQUEST, postcompanyconnectRequest, api),
        takeLatest(CompanyTypes.GETCOMPANYCONNECTIONS_REQUEST, getcompanyconnectionsRequest, api),
        takeLatest(CompanyTypes.GETUSERSUBSCRIPTIONS_REQUEST, getusersubscriptionsRequest, api),
        takeLatest(CompanyTypes.GETSUBSCRIPTIONREPORTS_REQUEST, getsubscriptionreportsRequest, api),
        takeLatest(CompanyTypes.GETSUBSCRIPTIONFREQUENCIES_REQUEST, getsubscriptionfrequenciesRequest, api),
        takeLatest(CompanyTypes.POSTADDSUBSCRIPTION_REQUEST, postaddsubscriptionRequest, api),
        takeLatest(CompanyTypes.POSTSAVESUBSCRIPTION_REQUEST, postsavesubscriptionRequest, api),

        takeLatest(CommunityTypes.ADDFORUMTOPIC_REQUEST, addforumtopicRequest, api),
        takeLatest(CommunityTypes.POSTCREATEBLOG_REQUEST, postcreateblogRequest, api),
        takeLatest(CommunityTypes.GETFORUMINDIVIDUALTOPIC_REQUEST, getforumindividualtopicRequest, api),
        takeLatest(CommunityTypes.ADDTOPICCOMMENT_REQUEST, addtopiccommentRequest, api),
        takeLatest(CommunityTypes.EDITFORUMTOPIC_REQUEST, editforumtopicRequest, api),
        takeLatest(CommunityTypes.DELETEFORUMTOPIC_REQUEST, deleteforumtopicRequest, api),
        takeLatest(CommunityTypes.GETBLOGSUMMARY_REQUEST, getblogsummaryRequest, api),
        takeLatest(CommunityTypes.GETBLOGDETAILS_REQUEST, getblogdetailsRequest, api),
        takeLatest(CommunityTypes.GETCOMMUNITYUSER_REQUEST, getcommunityuserRequest, api),
        takeLatest(CommunityTypes.GETCOMMUNITYBLOG_REQUEST, getcommunityblogRequest, api),
        takeLatest(CommunityTypes.GETCOMMUNITYCONNECTIONS_REQUEST, getcommunityconnectionsRequest, api),
        takeLatest(CommunityTypes.POSTCOMMUNITYCONNECT_REQUEST, postcommunityconnectRequest, api),
        takeLatest(CommunityTypes.GETUSERPERMISSIONS_REQUEST, getuserpermissionsRequest, api),
        takeLatest(CommunityTypes.POSTCOMMUNITYUSER_REQUEST, postcommunityuserRequest, api),
        takeLatest(CommunityTypes.POSTSAVEUSERCONTENT_REQUEST, postsaveusercontentRequest, api),
        takeLatest(CommunityTypes.POSTPASSWORDCHANGE_REQUEST, postpasswordchangeRequest, api),
        takeLatest(CommunityTypes.POSTUNFOLLOW_REQUEST, postunfollowRequest, api),
        takeLatest(CommunityTypes.POSTCONNECTIONUPDATE_REQUEST, postconnectionupdateRequest, api),
        takeLatest(CommunityTypes.POSTREGISTERUSER_REQUEST, postregisteruserRequest, api),
        takeEvery(CommunityTypes.GETTOPICS_REQUEST, gettopicsRequest, api),
        takeEvery(CommunityTypes.GETALLDEPARTMENTFORUMTOPICS_REQUEST, getalldepartmentforumtopicsRequest, api),
        takeEvery(CommunityTypes.GETCOMBLOGPOSTS_REQUEST, getcomblogpostsRequest, api),
        takeLatest(CommunityTypes.GETEDITFEATUREDITEMS_REQUEST, geteditfeatureditemsRequest, api),
        takeLatest(CommunityTypes.GETFEATUREDITEMS_REQUEST, getfeatureditemsRequest, api),
        takeLatest(CommunityTypes.GETFEATUREDCATEGORIES_REQUEST, getfeaturedcategoriesRequest, api),
        takeLatest(CommunityTypes.POSTSAVEFEATUREDITEM_REQUEST, postsavefeatureditemRequest, api),
        takeLatest(CommunityTypes.POSTARCHIVEFEATUREDITEM_REQUEST, postarchivefeatureditemRequest, api),
        takeEvery(CommunityTypes.GETCATEGORYSPONSOREDPRODUCTS_REQUEST, getcategorysponsoredproductsRequest, api),
        takeLatest(CommunityTypes.POSTSAVECOMMENT_REQUEST, postsavecommentRequest, api),
        takeLatest(CommunityTypes.POSTCONTENTFLAG_REQUEST, postcontentflagRequest, api),
        takeLatest(CommunityTypes.ADDCONTENTEVENT_REQUEST, addcontenteventRequest, api),
        takeLatest(CommunityTypes.FEATUREDPOSTS_REQUEST, featuredpostsRequest, api),
        takeLatest(CommunityTypes.GETEMPLOYERSEARCH_REQUEST, getemployersearchRequest, api),
    ]);
}
